import { useAsync, useMountEffect } from "@react-hookz/web";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";

import type { scmpPwaBurgerMenuConfigAppConfigQuery } from "scmp-app/queries/__generated__/scmpPwaBurgerMenuConfigAppConfigQuery.graphql";

export const useScmpPwaBurgerMenuConfig = () => {
  const environment = useRelayEnvironment();
  const [state, actions] = useAsync(async () => {
    const data = await fetchQuery<scmpPwaBurgerMenuConfigAppConfigQuery>(
      environment,
      graphql`
        query scmpPwaBurgerMenuConfigAppConfigQuery {
          appConfig(filter: { entityId: "scmp_pwa_burger_menu" }) {
            json
          }
        }
      `,
      {},
      {
        fetchPolicy: "store-or-network",
      },
    ).toPromise();

    if (!data?.appConfig?.json) return;
    const raw = data.appConfig.json as ScmpPwaBurgerMenuAppConfig;
    return raw.default.mobile;
  });

  useMountEffect(() => {
    void actions.execute();
  });

  return { scmpPwaBurgerMenuConfigState: state };
};

export type BurgerMenuItem = BurgerMenuItemChildren & {
  children?: BurgerMenuItemChildren[];
  text: string;
};

export type BurgerMenuItemChildren = {
  __typename: string;
  bulletStyle?: "newsletter" | "yellow-dot";
  entityId: string;
  entityUuid: string;
  hasNewTag: boolean;
  isExternal?: boolean;
  linkHref: string;
  text: string;
  urlAlias: string;
};

export type BurgerMenuTopTab = {
  button?: {
    text: string;
  };
  isActive?: boolean;
  items: BurgerMenuItem[];
  type: string;
};

type AppConfig<T> = {
  default: {
    mobile: T;
  };
};

type ScmpPwaBurgerMenuAppConfig = AppConfig<{
  tabs: BurgerMenuTopTab[];
  topTab: BurgerMenuTopTab;
}>;
